
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'b-button-group',
    setup() {
    },
});
